exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-results .loading[data-v-287fa4c4] {\n  display: flex;\n  flex: 1;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  min-height: 468px;\n}\n.search-results .component-fade-enter-active[data-v-287fa4c4],\n.search-results .component-fade-leave-active[data-v-287fa4c4] {\n  transition: opacity 0.3s ease;\n}\n.search-results .component-fade-enter[data-v-287fa4c4], .search-results .component-fade-leave-to[data-v-287fa4c4] {\n  opacity: 0;\n}", ""]);

// exports
